import { render, staticRenderFns } from "./PageRoyaume.vue?vue&type=template&id=08aa299a&"
import script from "./PageRoyaume.vue?vue&type=script&lang=js&"
export * from "./PageRoyaume.vue?vue&type=script&lang=js&"
import style0 from "./PageRoyaume.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports